module.exports = __webpack_public_path__ + "static/img/linyi5.c46ac7a4.jpg";